export default "__VITE_ASSET__DvYJcf45__"